import { useCallback } from 'react';
import useCookieStorage from '~/hooks/useCookieStorage';
import { LAST_SEARCH_URL_COOKIE_NAME } from '~/scripts/constants';
import { useRecaptcha } from '~/scripts/recaptcha';
import useDataLayer from '~/services/datalayer';
import type { Users } from '~/types';

export interface UseTrackSearchOptions {
  user: Users.User;
  total: number;
  name: string;
  uuid: string;
  url: string;
}
export function useTrackSearch() {
  const dataLayer = useDataLayer();
  const [_lastSearchUrl, setLastSearchUrl] = useCookieStorage(
    LAST_SEARCH_URL_COOKIE_NAME,
    ''
  );
  const getRecaptchaV3Token = useRecaptcha();
  return useCallback(
    ({ user, total, name, uuid, url }: UseTrackSearchOptions) => {
      dataLayer.push({
        event: 'search',
        user,
        total,
        name,
        uuid,
      });
      setLastSearchUrl(url);
      getRecaptchaV3Token('search');
    },
    [dataLayer, getRecaptchaV3Token, setLastSearchUrl]
  );
}
